import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ItemsTapMain from "./Items/ItemsTapMain";
import CategoryTapMain from "./Category/CategoryTapMain";

function TabPanel({ children, value, index }) {
	return (
		<div role="tabpanel" hidden={value !== index} id={`menu-tabpanel-${index}`} aria-labelledby={`menu-tab-${index}`}>
			{value === index && <Box sx={{ p: 2 }}><Typography component="div">{children}</Typography></Box>}
		</div>
	);
}

const LOCAL_KEY = "menuPage.selectedTab";

const MenuPage = () => {
	const [value, setValue] = useState(() => {
		try {
			const v = localStorage.getItem(LOCAL_KEY);
			return v !== null ? Number(v) : 0;
		} catch (e) {
			return 0;
		}
	});

	// persist selection so page refresh keeps current tab
	React.useEffect(() => {
		try {
			localStorage.setItem(LOCAL_KEY, String(value));
		} catch (e) {}
	}, [value]);

	return (
		<Paper sx={{ p: 2 }}>
			<Tabs value={value} onChange={(e, v) => setValue(v)} variant="fullWidth" textColor="primary" indicatorColor="primary">
				<Tab label="الفئات" id="menu-tab-0" aria-controls="menu-tabpanel-0" />
				<Tab label="الأصناف" id="menu-tab-1" aria-controls="menu-tabpanel-1" />
			</Tabs>

			<TabPanel value={value} index={0}>
					{/* Categories list component */}
					<CategoryTapMain />
			</TabPanel>

			<TabPanel value={value} index={1}>
				<ItemsTapMain />
			</TabPanel>
		</Paper>
	);
};

export default MenuPage;
